import { postInviteValidatePhoneApi } from 'src/api/yembo/invite';

type Props = { phone: string; companyKey?: string };

export const canPhoneReceiveSms = async (data: Props) => {
  const { canSendSms } = (await postInviteValidatePhoneApi({ data })) as {
    canSendSms: boolean;
  };
  return canSendSms;
};
